import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _, { isEmpty } from 'lodash'
import { Button, Col, Form, Icon, Input, Modal, Radio, Row, Upload } from 'antd'
import { FormItem } from '../../../../styles/shared.style'
import { ButtonEx } from '../../../../styles/button.style'
import { useDeepEffect } from '../../../../utils/hooks'
import { beforeUpload, compressFile, getBase64 } from '../../../../utils/services'
import axios from 'axios'

const NewsForm = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form
  const [imageUrl, setImageUrl] = useState('')
  const [file, setFile] = useState(null)

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        name: formData.name,
        url: formData.url,
        status: formData.enabled
      })
      setImageUrl(formData.newsItemImage)
    }

    return () => {
      form.resetFields()
      setImageUrl('')
      setFile(null)
    }
  }, [formData])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          name: values.name,
          url: values.url,
          enabled: values.status
        }
        if (values.image) {
          try {
            const formImgData = new FormData()
            if (!_.isNull(values.image.file)) {
              formImgData.append('image', await compressFile(values.image.file))
              const res = await axios.post(
                process.env.REACT_APP_API_ENDPOINT + `/newsItem/image`,
                formImgData,
                {
                  headers: {
                    'content-type': 'multipart/form-data'
                  }
                }
              )
              data.image = res.data.id
            }
          } catch (err) {
            console.log(err)
          }
        }else{
          data.image = formData.newsItemImageID
        }

        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
      }
    })
  }
  async function handleChange(info) {
    await getBase64(info.file, (imageUrl) => {
      setImageUrl(imageUrl)
    })
  }

  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  )

  return (
    <Modal
      title={`${!_.isEmpty(formData) ? 'Edit' : 'Create'} a News`}
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <Form.Item label="หัวข้อ">
          {getFieldDecorator(`name`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input
            name="name"
            placeholder="หัวข้อข่าว" />)}
        </Form.Item>
        <Form.Item label="URL">
          {getFieldDecorator(`url`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input
            name="url"
            placeholder="URL" />)}
        </Form.Item>
        <FormItem label="ป้าย">
          {getFieldDecorator(`image`, {
            rules: [
              {
                required: _.isEmpty(formData),
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Upload
            name="img"
            listType="picture-card"
            showUploadList={false}
            beforeUpload={(file) => beforeUpload(file)}
            onChange={handleChange}>
            {imageUrl ? (
              <img src={imageUrl} alt="img" style={{ width: '100%' }} />
            ) : (
              uploadButton
            )}
          </Upload>
          )}
        </FormItem>
        <Form.Item label="Status">
          {getFieldDecorator(`status`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Radio.Group>
              <Radio value={true}>Enabled</Radio>
              <Radio value={false}>Disabled</Radio>
            </Radio.Group>
          )}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

NewsForm.propTypes = {
  form: PropTypes.any,
  visible: PropTypes.bool.isRequired,
  formData: PropTypes.object.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

const WrappedNewsForm = Form.create({ name: 'NewsForm' })(
  NewsForm
)
export default WrappedNewsForm



// WEBPACK FOOTER //
// ./src/pages/News/components/NewsForm/index.js